import React from 'react';
import ReactDom from "react-dom";
import App from "../App";
import $ from "jquery";
import AOS from 'aos';
import 'aos/dist/aos.css';
import {BsDownload} from "react-icons/bs";

function ProfilePage() {
  $(function () {
    AOS.init();
  });

  return (
    <div id="ProfilePage" className="profile-page-div">
      <div className="profile-title-div">
        <h1 className="profile-title title-heading">About Me</h1>
        <hr className="title-hr" />
      </div>

      <div className="profile-intro">
        <p>
          Hey! My name is Stephen Kwak. I'm a current MSE CIS student at the
          University of Pennsylvania. I finished my undergrad at Pomona College
          as a Computer Science and Math double major, and played for the
          Pomona-Pitzer Varsity Baseball team as a pitcher. I have professional
          working experience as a software engineer intern for Meta and HP, and
          research experience at NerDS lab researching time series forecasting
          for neural population activity. I am passionate about making software
          tools that serve a purpose, creating solutions for problems that arise
          around me.
        </p>
      </div>

      <div className="prof-info">
        <div className="profile-pictures-section">
          <img className="profile-picture" src={`${process.env.PUBLIC_URL}/images/IMG_5433.jpeg`} alt="Profile" />
        </div>

        <div className="profile-demographic">
          <h2 className="title-heading2">More Details</h2>
          <table className="profile-table">
            <tbody>
              <tr>
                <td><p>Name:</p></td>
                <td><p>Stephen Kwak</p></td>
              </tr>
              <tr>
                <td><p>Location:</p></td>
                <td><p>San Jose, CA</p></td>
              </tr>
              <tr>
                <td><p>Hobbies:</p></td>
                <td><p>Golfing, Tennis, Baseball</p></td>
              </tr>
              <tr>
                <td><p>Favorite Food:</p></td>
                <td><p>Maeun Galbi JJim (매운갈비찜)</p></td>
              </tr>
              <tr>
                <td><p>Current Show:</p></td>
                <td><p>One Piece</p></td>
              </tr>
              <tr>
                <td><h3><b>Resume</b></h3></td>
                <td>
                  <div className="resume-button">
                    <a href={`${process.env.PUBLIC_URL}/Stephen_Kwak_resume.pdf`}>
                      <BsDownload style={{ fontSize: "2rem" }} />
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default ProfilePage;
